import type {
  CreateBugReportInput,
  ResolveBugReportInput,
  BugReportQueueQuery,
  BugReportQueueResponse,
  BugReportItem,
} from '../../schemas/bugReports.js';
import { buildQuery, type RequestFn } from '../http.js';

/**
 * Beta bug reports. Filing is open to any signed-in user; the queue + resolve
 * endpoints are gated server-side to platform moderators (same team as the
 * report queue).
 */
export function makeBugReportsApi(request: RequestFn) {
  return {
    /** Submit a beta bug report (description + optional screenshot uploadId). */
    createBugReport: (input: CreateBugReportInput) =>
      request<{ ok: true; id: string }>('/api/bug-reports', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    /** Read the bug-report queue (platform moderators only). */
    listBugReports: (query: BugReportQueueQuery = {}) =>
      request<BugReportQueueResponse>(`/api/bug-reports${buildQuery(query)}`),
    /** Resolve / dismiss a bug report (platform moderators only). */
    resolveBugReport: (id: string, input: ResolveBugReportInput) =>
      request<{ ok: true; report: BugReportItem }>(`/api/bug-reports/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
  };
}
